// extracted by mini-css-extract-plugin
export default {"root":"AudioRecorder_root__2U57j","recordButton":"AudioRecorder_recordButton__FS2Mp","timer":"AudioRecorder_timer__fjP7G"};